import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Activity } from "lucide-react";

export default function AuditLogPage() {
  const { data = [], isLoading } = useQuery({
    queryKey: ["audit-full"],
    queryFn: async () => (await apiClient.get("/activity-logs", { params:{ limit: 200 } })).data,
  });

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-widest text-[#00A651]">Sistem</div>
        <h1 className="text-2xl lg:text-3xl font-bold text-slate-900" style={{fontFamily:"Outfit"}}>Audit Trail / Activity Log</h1>
        <p className="text-sm text-slate-500 mt-1">Catatan seluruh perubahan data operasional.</p>
      </div>
      <Card className="border-slate-200">
        <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><Activity className="w-4 h-4 text-[#00A651]"/> Riwayat Aktivitas</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          {isLoading && Array.from({length:6}).map((_,i)=><Skeleton key={i} className="h-14 w-full rounded-lg"/>)}
          {!isLoading && data.length === 0 && <div className="text-sm italic text-slate-500 py-8 text-center">Belum ada aktivitas.</div>}
          {data.map(l => (
            <div key={l.id} className="flex items-start gap-3 p-3 rounded-lg border border-slate-100 hover:bg-slate-50">
              <div className="w-9 h-9 rounded-full bg-[#00A651]/10 text-[#00A651] flex items-center justify-center font-bold text-xs">{(l.user_name || "?").slice(0,2).toUpperCase()}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-sm text-slate-800">{l.user_name}</span>
                  <Badge variant="outline" className="text-[10px]">{l.action}</Badge>
                  <Badge className="bg-emerald-50 text-emerald-700 text-[10px]">{l.module}</Badge>
                </div>
                <div className="text-sm text-slate-600 mt-0.5">{l.description}</div>
                <div className="text-[11px] text-slate-400 mt-0.5">{new Date(l.timestamp).toLocaleString("id-ID")}</div>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
